$(document).on('click', '.togglePassword', function (e) {
    var $this = $(this);
    var $passwordInput = $this.siblings('input[type="password"], input[type="text"]');
    var currentType = $passwordInput.attr('type');
    var newType = currentType === 'password' ? 'text' : 'password';
    
    $passwordInput.attr('type', newType);

    // Toggle the icon class
    $this.toggleClass('fa-eye fa-eye-slash');
});